export default "__VITE_ASSET__zWEwuOJh__"